import styled from 'styled-components';

export const PlansStyle = styled.div`
  width: 100%;
  min-height: calc(100vh - 33px);
  font-size: 16px;
  line-height: 20px;
  padding: 20px 0 10px;
  display: flex;
  flex-direction: column;
  position: relative;

  .btn-back {
    position: absolute;
    top: 66px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 50px;
    border-radius: 8px;
    border: 1px solid var(--border);
    background: var(--card-bg);
    font-size: 20px;
    color: var(--white);

    @media (min-width: 768px) {
      height: 40px;
    }
    @media (min-width: 1200px) {
      top: 0;
    }
  }

  .header {
    width: 100%;
    text-align: center;
    margin-bottom: 30px;
    padding: 0 50px;

    h1 {
      margin: 0 0 20px;
      font-weight: 800;
      color: var(--white);
    }
  }

  .tab-btns {
    max-width: 250px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 5px;
    border-radius: 8px;
    border: 1px solid var(--border);
    background: var(--card-bg);

    .btn {
      flex-grow: 1;
      display: inline-block;
      font-size: 16px;
      line-height: 20px;
      font-weight: 600;
      padding: 10px;
      border-radius: 6px;
      color: var(--white);
      background: transparent;

      &:hover,
      &.active {
        background: var(--white);
        color: var(--text-color);
      }
    }
  }

  .tab-content {
    flex-grow: 1;
    max-width: 1300px;
    width: 100%;
    margin: 0 auto 40px;
  }

  .plan-wrap {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 20px;
  }

  .plan-col {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 500px;
    padding: 20px;
    border-radius: 12px;
    border: 1px solid var(--border);
    background: var(--card-bg);

    .text-box {
      width: 100%;
      min-height: 160px;
      margin-bottom: 25px;

      .title {
        display: block;
        font-size: 24px;
        line-height: 28px;
        font-weight: 700;
        margin-bottom: 8px;
      }
    }

    .price-box {
      display: flex;
      align-items: center;
      gap: 6px;
      color: var(--light-gray);
      padding-top: 25px;

      .price {
        display: block;
        font-size: 28px;
        line-height: 32px;
        font-weight: 800;
        color: var(--white);
      }

      .text {
        display: block;
      }
    }

    .feature-list {
      flex-grow: 1;

      li {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;

        .icon {
          flex-shrink: 0;
        }
      }
    }

    button {
      margin-bottom: 20px;
      font-weight: 700;
      padding: 15px 10px;
      color: var(--text-color);
    }
  }

  .footer {
    width: 100%;
    text-align: center;

    .text-holder {
      max-width: 400px;
      margin: 0 auto;
      font-size: 16px;
      line-height: 20px;

      p {
        margin-bottom: 20px;
      }
    }
  }
`;
